import { render, staticRenderFns } from "./addChangeNeed.vue?vue&type=template&id=60b0dc89&scoped=true&"
import script from "./addChangeNeed.vue?vue&type=script&lang=js&"
export * from "./addChangeNeed.vue?vue&type=script&lang=js&"
import style0 from "./addChangeNeed.vue?vue&type=style&index=0&id=60b0dc89&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b0dc89",
  null
  
)

export default component.exports